import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../app/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Aweb';

  // On app-root so one global sheet reaches every header (incl. legacy ones); defaults to teal when permissions absent.
  @HostBinding('class.theme-header-light')
  get whiteHeader(): boolean {
    return !!this.loginS.premissions?.WhiteHeader;
  }

  // Marks legacy-sidebar mode on the root so the header can restyle its left edge against the old sidebar.
  @HostBinding('class.old-sidebar')
  get oldSidebar(): boolean {
    return !this.loginS.newSidebar;
  }

  constructor(
    public loginS: LoginService,
    public router: Router,
    private translate: TranslateService
  ) {
    // Boot straight into the user's last interface language so the app (and the
    // post-login dashboard) never flashes English before the getTOS switch lands.
    // Starts loading the translation file now, so it's active/cached before render.
    const storedLang = localStorage.getItem('interfaceLang');
    if (storedLang) {
      this.translate.use(storedLang);
    }
  }

  // The sidebar shell belongs to authenticated in-app routes only. It must never
  // overlay the login page (path '') — even when the user is still authenticated
  // and returns to it via the browser Back button.
  get showSidebar(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return (
      !!this.loginS.username &&
      !this.loginS.clinicOptions &&
      path !== '/' &&
      path !== '/privacy-policy'
    );
  }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    // Clean '_v' we added to force the browser to get the new V
    if (url.searchParams.has('_v')) {
      url.searchParams.delete('_v');
      window.history.replaceState({}, document.title, url.toString());
    }
  }
}
